import { IConfigurationRead } from '../interfaces/campaign-v2.types'
import { hasContentEdits, useCampaignV2Store } from './editor.store'

const snapshot = () => {
   const s = useCampaignV2Store.getState()
   return structuredClone({
      campaignId: s.campaignId,
      name: s.name,
      config: s.config,
      revision: s.revision,
      status: s.status,
      publishedVersionId: s.publishedVersionId,
      activeVersionId: s.activeVersionId,
      hasUnpublishedChanges: s.hasUnpublishedChanges,
      dirty: s.dirty,
      step: s.step,
      visited: s.visited,
      categoryLabels: s.categoryLabels,
      contentIndex: s.contentIndex,
      audienceLabels: s.audienceLabels,
      conflict: s.conflict,
      contentDrafts: s.contentDrafts,
      dynamicCriteria: s.dynamicCriteria,
   })
}

/** Unsaved work survives SPA navigation in this tab. Nothing is written to the server. */
const copies = new Map<
   string,
   { state: ReturnType<typeof snapshot>; initial: IConfigurationRead | null }
>()
export const workingCopyKey = (org: string | null | undefined, id?: string) =>
   JSON.stringify([org, id || 'new'])
export const forgetWorkingCopy = (key: string) => copies.delete(key)
export const keepWorkingCopy = (
   key: string,
   initial: IConfigurationRead | null
) => {
   const s = useCampaignV2Store.getState()
   if (!s.config || (!s.dirty && !hasContentEdits(s.contentDrafts))) {
      copies.delete(key)
      return
   }
   copies.set(key, { state: snapshot(), initial: structuredClone(initial) })
}
export const restoreWorkingCopy = (key: string, fresh?: IConfigurationRead) => {
   const saved = copies.get(key)
   if (!saved) return null
   useCampaignV2Store.setState({
      ...structuredClone(saved.state),
      ...(fresh
         ? {
              status: fresh.status,
              activeVersionId: fresh.activeVersionId,
              publishedVersionId: fresh.publishedVersionId,
              conflict: fresh.revision !== saved.state.revision ? fresh : null,
           }
         : {}),
   })
   return structuredClone(saved)
}
